// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("./GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.endCursor;
  var value$2 = value.startCursor;
  return {
          endCursor: !(value$1 == null) ? Caml_option.some(GraphqlHelpers.Cursor.parse(value$1)) : undefined,
          hasNextPage: value.hasNextPage,
          hasPreviousPage: value.hasPreviousPage,
          startCursor: !(value$2 == null) ? Caml_option.some(GraphqlHelpers.Cursor.parse(value$2)) : undefined
        };
}

function serialize(value) {
  var value$1 = value.startCursor;
  var startCursor = value$1 !== undefined ? Curry._1(GraphqlHelpers.Cursor.serialize, Caml_option.valFromOption(value$1)) : null;
  var value$2 = value.hasPreviousPage;
  var value$3 = value.hasNextPage;
  var value$4 = value.endCursor;
  var endCursor = value$4 !== undefined ? Curry._1(GraphqlHelpers.Cursor.serialize, Caml_option.valFromOption(value$4)) : null;
  return {
          endCursor: endCursor,
          hasNextPage: value$3,
          hasPreviousPage: value$2,
          startCursor: startCursor
        };
}

function verifyArgsAndParse(_Paging_PageMarkers, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function hasMorePages(param_0) {
  return /* HasMorePages */{
          _0: param_0
        };
}

function compare(param) {
  var a = param[0];
  if (typeof a === "number") {
    if (a !== 0) {
      var match = param[1];
      if (typeof match === "number" && match !== 0) {
        return "equal_to";
      } else {
        return "greater_than";
      }
    }
    var match$1 = param[1];
    if (typeof match$1 === "number" && match$1 === 0) {
      return "equal_to";
    } else {
      return "less_than";
    }
  }
  var b = param[1];
  if (typeof b === "number") {
    if (b !== 0) {
      return "less_than";
    } else {
      return "greater_than";
    }
  } else {
    return Curry._2(GraphqlHelpers.Cursor.compare, a._0, b._0);
  }
}

function eq(param) {
  return Relude_Globals.$great$great(compare, (function (param) {
                return "equal_to" === param;
              }), param);
}

function compare$1(param, param$1) {
  return Relude_Function.curry2(compare, param, param$1);
}

function eq$1(param, param$1) {
  return Relude_Function.curry2(eq, param, param$1);
}

var Cursor = {
  init: /* Init */0,
  hasMorePages: hasMorePages,
  noMorePages: /* NoMorePages */1,
  compare: compare$1,
  eq: eq$1
};

var $$default = {
  next: /* Init */0,
  prev: /* Init */0
};

function tToR(param) {
  var hasPreviousPage = param.hasPreviousPage;
  var hasNextPage = param.hasNextPage;
  return {
          next: Relude_Option.fold(/* NoMorePages */1, hasMorePages, Relude_Option.keep(function (param) {
                      return Relude_Globals.$$const(hasNextPage, param);
                    })(param.endCursor)),
          prev: Relude_Option.fold(/* NoMorePages */1, hasMorePages, Relude_Option.keep(function (param) {
                      return Relude_Globals.$$const(hasPreviousPage, param);
                    })(param.startCursor))
        };
}

function parseApiResonse(apiResponse) {
  var partial_arg = apiResponse.hasNextPage;
  var partial_arg$1 = apiResponse.hasPreviousPage;
  return {
          next: Relude_Option.fold(/* NoMorePages */1, hasMorePages, Relude_Option.keep(function (param) {
                      return Relude_Globals.$$const(partial_arg, param);
                    })(apiResponse.endCursor)),
          prev: Relude_Option.fold(/* NoMorePages */1, hasMorePages, Relude_Option.keep(function (param) {
                      return Relude_Globals.$$const(partial_arg$1, param);
                    })(apiResponse.startCursor))
        };
}

function parseMaybeApiResonse(apiResponse) {
  return Relude_Option.fold($$default, (function (x) {
                return parseApiResonse(x.pageInfo);
              }), apiResponse);
}

function combine(direction, param, param$1) {
  if (direction) {
    return {
            next: param.next,
            prev: param$1.prev
          };
  } else {
    return {
            next: param$1.next,
            prev: param.prev
          };
  }
}

function compare$2(param) {
  var match = param[1];
  var match$1 = param[0];
  var other = Relude_Function.curry2(compare, match$1.next, match.next);
  if (other === "less_than" || other === "greater_than") {
    return other;
  } else {
    return Relude_Function.curry2(compare, match$1.prev, match.prev);
  }
}

function eq$2(param) {
  return Relude_Globals.$great$great(compare$2, (function (param) {
                return "equal_to" === param;
              }), param);
}

function compare$3(param, param$1) {
  return Relude_Function.curry2(compare$2, param, param$1);
}

function eq$3(param, param$1) {
  return Relude_Function.curry2(eq$2, param, param$1);
}

var query = "fragment Paging_PageMarkers on PageInfo   {\nendCursor  \nhasNextPage  \nhasPreviousPage  \nstartCursor  \n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.Cursor = Cursor;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.tToR = tToR;
exports.parseApiResonse = parseApiResonse;
exports.parseMaybeApiResonse = parseMaybeApiResonse;
exports.combine = combine;
exports.compare = compare$3;
exports.eq = eq$3;
/* Relude_Option Not a pure module */
